import type { SVGProps } from 'react';
const SvgIconBank = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.713 1.232a1.25 1.25 0 0 0-1.426 0L1.543 5.223c-1.006.7-.512 2.277.713 2.277H2.5V11A1.5 1.5 0 0 0 1 12.5v1A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-1a1.5 1.5 0 0 0-1.5-1.5V7.5h.244c1.225 0 1.719-1.578.713-2.277zM3.053 6 8 2.563 12.946 6zM12 7.5h-1.667V11H12zm-3.167 0H7.167V11h1.666zm-3.166 0H4V11h1.667zm7.833 5h-11v1h11z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconBank;
